<template>
	<section class="mysection">
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-select 
						v-model="filters.provider_code" filterable placeholder="请选择提供商" class="h-m-select">
					  <el-option v-for="item in tgs_options"
						:key="item.code" :label="item.name" v-model="item.code">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<div v-for="item in datalist" v-loading="listLoading">
		<el-col :span="8">
			<div class="div-cards">
				<el-button type="primary" icon="el-icon-edit" circle size="mini" @click="handleEdit(item)"></el-button>
				<!--
				<el-button type="danger" icon="el-icon-delete" circle size="mini" @click="handleDel(scope.$index, scope.row)"></el-button>
				-->
				<el-divider content-position="right" class="var-text">{{showTgs(item.provider_code)}}</el-divider>
				<div v-if="item.status==1" class="text item">{{item.name}}</div>
				<div v-else class="text items">{{item.name}}</div>
				<div class="itemmin">
				  SID:{{item.script_id}}<br/>
				  IID:{{item.instance_id}}
				</div>
				<div v-for="ins in item.variables" class="var-text"> 
					{{ins.kn}}
				</div>
			</div>
		</el-col>
		</div>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		<!--新增界面-->
		<el-drawer
		  v-loading="editViewLoading" 
		  title="新增"
		  :visible.sync="addFormVisible" :before-close="clickClose"
		  size="40%" :with-header="false"
		  direction="rtl">
			<el-form :model="editForm" label-width="80px" :rules="formRules" ref="editForm">
				<el-container style="min-height: 100vh;">
					<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
					  <!-- 头部内容 -->			  
					  <div class="to-right">
						<el-button @click.native="addFormVisible = false">取消</el-button>
						<el-button type="primary" @click.native="editSubmit" :loading="editLoading">保存</el-button>
					  </div>
					</el-header>
					<el-main>
						<el-form-item label="提供商" class="is-required">
							{{showTgs(editForm.provider_code)}}
						</el-form-item>
						<el-form-item label="选择实列" prop="instance_id" class="is-required">
							<el-select 
								@change="selectIntances"
								v-model="editForm.instance_id" filterable placeholder="请输入/请选择" class="h-m-select">
							  <el-option v-for="item in instance_opts"
								:key="item.instanceId" :label="item.instanceName" v-model="item.instanceId">
							  </el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="选择脚本" v-loading="scriptLoading"  prop="script_id" class="is-required">
							<el-select 
								@change="selectScripts"
								v-model="editForm.script_id" filterable placeholder="请输入/请选择" class="h-m-select">
							  <el-option v-for="item in script_opts"
								:key="item.scriptId" :label="item.scriptName" v-model="item.scriptId">
							  </el-option>
							</el-select>
						</el-form-item>
						<!-- 
						<el-card class="box-card">
						  <div slot="header" class="clearfix"><span>{{editformtitle}}</span></div>
						  <div class="text item">
						  </div>
						</el-card>	
						-->
					</el-main>
				</el-container>
			</el-form>
		</el-drawer>
		<el-drawer
		  title="编辑"
		  :visible.sync="editFormVisible" :before-close="clickClose"
		  size="60%" :with-header="false"
		  direction="rtl">
			<el-form :model="editForm" label-width="80px" :rules="formRules" ref="editForm">
				<el-container style="min-height: 100vh;">
					<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
					  <!-- 头部内容 -->
					  <div class="to-right">
						<el-button @click.native="editFormVisible = false">取消</el-button>
						<el-button type="primary" @click.native="editSaveSubmit" :loading="editLoading">保存</el-button>
					  </div>
					</el-header>
					<el-main>
						<el-card class="box-card">
						  <div slot="header" class="clearfix"><span>{{editformtitle}}</span></div>
						  <div>
							<el-form-item label="提供商">
								{{showTgs(editForm.provider_code)}}
							</el-form-item>
							<el-form-item label="实列ID">
								{{editForm.instance_id}}
							</el-form-item>
							<el-form-item label="脚本ID">
								{{editForm.script_id}}
							</el-form-item>
							<el-form-item label="名称" class="is-required">
								<el-input v-model="editForm.name"></el-input>
							</el-form-item>
							<el-form-item label="状态" class="is-required">
								<el-select v-model="editForm.status" placeholder="请选择状态">
									<el-option label="有效" value="1"></el-option>
									<el-option label="无效" value="2"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="变量信息" class="is-required">
								<el-button v-if="!addVarsShow" type="primary" icon="el-icon-plus" circle size="mini" @click="addVars()"></el-button>
								<el-table stripe :data="loabvarstr" highlight-current-row row-style="var-text">
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-row>
												<el-button type="danger" icon="el-icon-delete" circle size="mini" @click="removeVars(scope.row.kn)"></el-button>
											</el-row>
										</template>
									</el-table-column>
									<el-table-column prop="kn" label="变量名">
									</el-table-column>
									<el-table-column prop="val" label="值">
									</el-table-column>
									<el-table-column prop="rk" label="描述">
									</el-table-column>
								</el-table>
							</el-form-item>
						
							
						
						  </div>
						</el-card>		
					</el-main>
				</el-container>
			</el-form>
		</el-drawer>
		<el-drawer
		  v-loading="editViewLoading" 
		  title="新增变量"
		  :visible.sync="addVarsShow" :before-close="clickClose"
		  size="40%" :with-header="false"
		  direction="rtl">
			<el-form :model="addVarForm" label-width="80px" ref="addVarForm">
				<el-container style="min-height: 100vh;">
					<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
					  <!-- 头部内容 -->
					  <div>
						<el-button @click.native="addFormVisible = false">取消</el-button>
						<el-button type="primary" @click.native="addSaveVars">保存</el-button>
					  </div>
					</el-header>
					<el-main>
						<el-card class="box-card">
						  <div slot="header" class="clearfix"><span>{{editformtitle}}</span></div>
						  <div class="text item">
							<el-form-item label="变量名" class="is-required">
								<el-input v-model="addVarForm.kn"></el-input>
							</el-form-item>
							<el-form-item label="变量值">
								<el-input v-model="addVarForm.val"></el-input>
							</el-form-item>
							<el-form-item label="变量描述">
								<el-input v-model="addVarForm.rk"></el-input>
							</el-form-item>
						  </div>
						</el-card>		
					</el-main>
				</el-container>
			</el-form>
		</el-drawer>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	//import NProgress from 'nprogress'
	import { getListPage, delData, saveData } from '../../api/api';

	export default {
		data() {
			return {
				filters: {
					provider_code: ''
				},
				datalist: [],
				total: 0,
				pagesize:15,
				page: 1,
				listLoading: false,
				scriptLoading:false,

				/////////////Form 表单
				editViewLoading:false,
				editformtitle:'',//form编辑名称
				addFormVisible:false,
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					instance_id: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					],
					username: [
						{ required: true, message: '请输入账号', trigger: 'blur' }
					]
				},
				tgs_options:[],
				instance_opts:[],
				script_opts:[],
				//编辑界面数据
				editForm: {
					actionurl:'',
					sqlid:'',
					id: 0,
					instance_id: '',
					provider_code:'',
					name:'',
					script_id:'',
					variables:'',
					status:''					
				},
				addVarForm:{
					kn:'',val:'',rk:''
				},
				loabvarstr:[],
				addVarsShow:false,
			}
		},
		methods: {
			removeVars:function(keystr){
				let index = this.loabvarstr.findIndex(item => item.kn === keystr);
				if (index !== -1) {
					this.loabvarstr.splice(index, 1);
				}
			},
			removeScript:function(keystr){
				let index = this.script_opts.findIndex(item => item.scriptId === keystr);
				console.log("检测:"+keystr);
				if (index !== -1) {
					this.script_opts.splice(index, 1);
				}
			},
			addVars:function(){
				this.addVarForm.kn = '';
				this.addVarForm.rk = '';
				this.addVarForm.val = '';
				this.addVarsShow = true ;
			},
			addSaveVars:function(){
				let newadd = {
					kn:this.addVarForm.kn,
					val:this.addVarForm.val,
					rk:this.addVarForm.rk
				};
				this.loabvarstr.push(newadd);
				this.addVarsShow = false ;
			},
			clickClose:function(){},
			formatType: function (row) {
				if(row.type==1) return '系统用户:'+row.cpname;
				if(row.type==2) return '业务员:'+row.cpname;
				if(row.type==3) return '企业用户:'+row.cpname;
				return '未知';
			},
			formatValid: function (row, column) {
				return row.valid == 1 ? '有效' : row.valid == 0 ? '无效' : '未知';
			},
			formatTgs:function(row,column){
				return this.showTgs(row.provider_code);
			},
			showTgs:function(providerCode){
				console.log(">>>"+providerCode);
				var restr = '' ;
				this.tgs_options.forEach(function(d){
					if(providerCode==d.code){
						restr = d.name;
						return ;
					}
				});
				return restr;
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getLists();
			},
			selectScripts(event){
				console.log(event);
			},
			selectIntances(event){
				let para = {
					actionurl:'calls/getScriptsList',instance_id:this.editForm.instance_id,
					provider_code:this.filters.provider_code
				};
				this.scriptLoading = true ;
				getListPage(para).then((res) => {
					this.scriptLoading = false ;
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.script_opts = res.data.datas;
						//准备将多余的删除
						//this.datalist.forEach(function(d){
						//	console.log(">>"+d.script_id);
						//	this.removeScript(d.script_id);
						//});
					}
				});
			},
			getTgsOptions(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'upwFgHtp.provider.options',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.tgs_options = res.data.datas;
					}
				});
			},
			//获取用户列表
			getLists() {
				//console.log("query");
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					provider_code: this.filters.provider_code,
					actionurl:'default/getList',
					sqlid:'RkAe8K0e.callScript.query',
				};
				this.listLoading = true;
				//NProgress.start();
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
					//NProgress.done();
				});
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { 
						id: row.id,
						actionurl:'default/del',
						sqlid:'RkAe8K0e.callScript.del'
					};
					delData(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
						this.getLists();
					});
				}).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				if(row.variables instanceof Object){
					this.loabvarstr = row.variables;
				}else{
					this.loabvarstr = [];
				}
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'RkAe8K0e.callScript.upt';//设置Sqlid
			},
			//显示新增界面
			handleAdd: function () {
				if(this.filters.provider_code=='') {
					this.$message({message: '请选择提供商!',type: 'error'});
					return ;
				}
				
				this.editViewLoading = true ;//打开加载
				this.addFormVisible = true ;
				//////////
				let para = {
					actionurl:'calls/getInstanceList',provider_code:this.filters.provider_code
				};
				getListPage(para).then((res) => {
					this.editViewLoading = false;
					if(res.data.status==-200){
					}else{
						this.instance_opts = res.data.datas;
					}
				});
				//////////////////////////////////
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',
					sqlid:'RkAe8K0e.callScript.add',
					provider_code: this.filters.provider_code,
					instance_id: '', name:'',
					script_id:'',
					variables:'',
					status:'1'
				};
			},
			showScriptName:function(scriptId){
				var restr = '' ;
				this.script_opts.forEach(function(d){
					if(scriptId==d.scriptId){
						restr = d.scriptName;
						return ;
					}
				});
				return restr;
			},
			//编辑保存
			editSubmit: function () {
				//console.log('script_id>>'+this.editForm.script_id);
				this.editForm.name = this.showScriptName(this.editForm.script_id);
				//this.editForm.variables = JSON.stringify(this.loabvarstr);
				let para = Object.assign({}, this.editForm);
				//util.saveFunction(this,para);
				util.saveParamFunction(this,para,'editLoading','editForm','addFormVisible');
			},
			editSaveSubmit: function () {
				//console.log('script_id>>'+this.editForm.script_id);
				this.editForm.variables = JSON.stringify(this.loabvarstr);
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			}
		},
		mounted() {
			this.getTgsOptions();
			this.getLists();
		}
	}
</script>
<style>
	.el-header {
	  background-color:#7a8295;
	  //color: white;
	  text-align: left;
	  line-height: 60px;
	}
	.to-right{
		position: fixed;
		right: 20px;
	}
	.text {
		font-size: 15px;
	}
	.var-text {
		font-size: 12px;
	}
	.item {
		margin-bottom: 18px;
		color:green;
	}
	.items {
		margin-bottom: 18px;
		color:red;
	}
	.itemmin{
		color:#858a95;
		font-size: 10px;
	}
	.div-cards {
		margin-bottom:15px;
		margin-left:15px;
		//width: 280px;
		height: 220px;
		padding:5px;
		border:dashed;
		border-color:#e6a23c;
		border-width:0.5px;
	}
	.div-vars{
		width: 280px;
		height: 28px;
		border:dashed;
		border-color:#e6a23c;
		border-width:0.5px;
	}
</style>


// WEBPACK FOOTER //
// callScript.vue?4801dc06